<template>
  <div>
    <div v-if="$q.platform.is.mobile">
      <q-layout view="hHh lpR fFf" v-if="!showDisclaimerOverlay">
        <q-header elevated>
          <div v-if="tenantLogoGuid" style="background-color: #b2b2b2; max-height: 100px !important;">
            <q-toolbar>
              <div class="row items-center full-width">
                <!-- Tenant Logo -->
                <div class="col-5">
                  <img v-if="tenantLogoGuid"
                  :src="logoPath + tenantLogoGuid"
                  class="q-mr-xs tenant-logo"
                  @error="handleImageError"
                  />
                </div>
                <!-- Tenant Name -->
                <div class="col-7">
                  <div
                    class="text-weight-bolder text-white q-pa-xs"
                    style="font-size: 1.3em; padding-left: 5px; color: #514d4d;"
                  >
                    {{ tenantName }}
                  </div>
                </div>
              </div>
            </q-toolbar>
          </div>
          <div v-else style="background-color: #b2b2b2; max-height: 45px !important">
            <q-toolbar>
              <div class="row justify-evenly items-center full-width">
                <div
                  class="text-weight-bolder q-pa-xs"
                  style="font-size: 0.9em"
                >
                  {{ $t('message.designDisclaimerHeader') }}
                </div>
                <div>
                  <img
                    src="../assets/disclaimer/WhatsApp_logo.png"
                    style="max-width: 150px; filter: brightness(0) invert(1);"
                  />
                </div>
              </div>
            </q-toolbar>
          </div>
        </q-header>

        <q-page-container>
          <div
            class="bg-image row full-width items-center justify-center"
            :style="contentHeight()"
          >
            <div class="col-8 row full-width justify-center items-center">
              <q-carousel
                v-model="currentIndex"
                transition-prev="slide-right"
                transition-next="slide-left"
                swipeable
                animated
                control-color="white"
                prev-icon="arrow_left"
                next-icon="arrow_right"
                navigation
                padding
                height="60vh"
                class="text-white shadow-2 custom-area bg-whatsapp"
                :style="swipableAreaStyle()"
                ><q-carousel-slide name="1" class="column no-wrap flex-center">
                  <img
                    src="../assets/disclaimer/mobile_device.png"
                    style="max-height: 220px"
                    draggable="false"
                  />
                  <div class="q-mt-md text-center">
                    {{ step1Text() }}
                  </div>
                </q-carousel-slide>
                <q-carousel-slide name="2">
                  <div class="row justify-center q-pb-md">
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >1.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div
                      class="text-center text-black col-auto"
                      style="font-size: 0.95rem"
                    >
                      {{ $t('message.designDisclaimerStep2_1Text') }}
                      <div class="text-bold" v-if="showDisclaimerText">
                        {{ $t('message.designDisclaimerStep2_2Text') }}
                      </div>
                    </div>
                    <div class="col col-4">
                      <div class="row justify-center items-center q-pt-sm">
                        <img
                          src="../assets/disclaimer/check.png"
                          draggable="false"
                          style="max-height: 40px"
                        />
                      </div>
                    </div>
                  </div>
                </q-carousel-slide>
                <q-carousel-slide name="3">
                  <div class="row justify-center q-pb-md">
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >2.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div class="text-center text-black col-auto">
                      <div class="text-bold">
                        {{ $t('message.designDisclaimerStep3_1Text') }}
                      </div>
                      {{ $t('message.designDisclaimerStep3_2Text') }}
                    </div>
                    <div class="col col-6 q-pt-sm">
                      <img
                        src="../assets/disclaimer/start.png"
                        draggable="false"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </q-carousel-slide>
                <q-carousel-slide name="4">
                  <div class="row justify-center q-pb-md">
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >3.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div class="text-center text-black col-auto">
                      {{ $t('message.designDisclaimerStep4_1Text') }}
                      <div class="text-bold">
                        {{ $t('message.designDisclaimerStep4_2Text') }}
                      </div>
                    </div>
                    <div class="col col-8 q-pt-sm">
                      <img
                        :src="chatImageSrc()"
                        draggable="false"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </q-carousel-slide>
                <q-carousel-slide name="5">
                  <div class="row justify-center q-pb-md">
                    <div
                      class="row full-width justify-center items-center q-pb-md"
                    >
                      <q-avatar
                        class="bg-whatsapp text-bold shadow-4"
                        size="50px"
                        font-size="26px"
                        >4.</q-avatar
                      >
                    </div>
                    <div
                      class="column justify-evenly"
                      style="height: 90%; max-height: 50vh"
                    >
                      <div class="text-center text-black col-auto">
                        {{ $t('message.designDisclaimerStep5_1Text') }}
                        <div class="text-bold">
                          {{ $t('message.designDisclaimerStep5Text') }}
                        </div>
                      </div>
                      <div class="col col-10 q-pt-sm">
                        <img
                          src="../assets/disclaimer/shoes.png"
                          draggable="false"
                          style="height: 100%; max-height: 20vh"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="q-pt-sm">
                    <div
                      class="bg-whatsapp corners row items-center justify-center full-width shadow-2"
                      style="font-size: 1.2rem; height: 40px"
                      @click="onSubmitApply"
                    >
                      {{ $t('message.designDisclaimerStep5_2Text') }}
                    </div>
                  </div>
                </q-carousel-slide>
              </q-carousel>
            </div>
          </div>
        </q-page-container>

        <q-footer
          elevated
          style="background-color: #b2b2b2"
          v-if="showDisclaimerText || showSubmitBtn"
        >
          <q-slide-transition appear>
            <div>
              <div
                class="row justify-center items-center full-width q-pa-sm"
                v-if="showDisclaimerText"
              >
                <div class="col-auto">
                  <q-checkbox
                    :disable="showQrCode"
                    size="lg"
                    @update:model-value="onAnyChange"
                    v-model="acceptWhatsappDataPrivacy"
                    dark
                    color="whatsapp"
                    v-if="!hideDisclaimerCheckbox"
                  />
                </div>
                <div
                  class="col text-white"
                  @click="
                    !hideDisclaimerCheckbox && !showQrCode
                      ? (acceptWhatsappDataPrivacy = !acceptWhatsappDataPrivacy)
                      : true
                  "
                >
                  <q-field
                    style="font-size: 0.55rem !important"
                    borderless
                    dense
                    hide-bottom-space
                    color="white"
                    ref="acceptWhatsappDataPrivacyRef"
                    :value="acceptWhatsappDataPrivacy"
                    ><div class="column">
                      <i18n-t :keypath="dataPrivacyText()" tag="div">
                        <template #termsOfUsageUrl>
                          <a
                            :href="termsOfUseLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.termsOfUseLbl') }}</a
                          >
                        </template>
                        <template #addnlTermsOfUsageUrl>
                          <a
                            :href="addnlTermsOfUsageUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ addnlTermsOfUsageLbl() }}</a
                          >
                        </template>
                        <template #pitchYouTermsOfUsageUrl>
                          <a
                            :href="termsOfUseLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.pitchYouTermsOfUseLbl') }}</a
                          >
                        </template>
                        <template #dataPrivacyUrl>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ dataPrivacyLabel() }}</a
                          >
                        </template>
                        <template #dataPrivacyFrameworkUrl>
                          <a
                            :href="dataPrivacyFrameworkUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ dataPrivacyFrameworkLabel }}</a
                          >
                        </template>
                        <template #privacyShieldUrl>
                          <a
                            :href="privacyShieldUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ privacyShieldLabel() }}</a
                          >
                        </template>
                        <template #dataPrivacyInfoUrl>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyInfoLbl') }}</a
                          >
                        </template>
                        <template #dataPrivacyUrlAlt>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyLblAlt') }}</a
                          >
                        </template>
                        <template #additionalTermsUrl>
                          <a
                            :href="additionalTermsLink()"
                            target="_blank"
                            class="text-white"
                            >{{ addnlTermsLbl() }}</a
                          >
                        </template>

                        <template #additionalTermsUrlAlt>
                          <a
                            :href="additionalTermsLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.moreInformationLabelAlt') }}</a
                          >
                        </template>

                        <template #imprintUrl>
                          <a
                            :href="imprintUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.legalNoticeFLbl') }}</a
                          >
                        </template>

                        <template #pitchyouDisclaimer>
                          <a
                            :href="$t('message.defaultDataPrivacyLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyLbl') }}</a
                          >
                        </template>
                        <template #pitchyouImprint>
                          <a
                            :href="$t('message.defaultImprintLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.legalNoticeFLbl') }}</a
                          >
                        </template>
                        <template #pitchyouTermsOfUse>
                          <a
                            :href="$t('message.defaultTermsOfUseLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.termsOfUseLbl') }}</a
                          >
                        </template>
                        <template #whatsAppDisclaimer>
                          <a
                            :href="$t('message.defaultWhatsAppDataPrivacyLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyTitle') }}</a
                          >
                        </template>
                        <template #whatsAppDataPrivacyUrl>
                          <a
                            :href="whatsAppDataPrivacyUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ whatsAppDataPrivacyLbl() }}</a
                          >
                        </template>
                        <template #whatsAppTermsOfUsageUrl>
                          <a
                            :href="whatsAppTermsOfUsageUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ whatsAppTermsOfUsageLbl() }}</a
                          ></template
                        ><template #newLine>
                          <div style="padding-top: 3px"></div>
                        </template>
                        <template #tcDataPrivacy>
                          <a
                            :href="$t('message.tcDataPrivacy')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyLbl') }}</a
                          >
                        </template>
                        <template #tcImprint>
                          <a
                            :href="$t('message.tcImprint')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.legalNoticeFLbl') }}</a
                          >
                        </template>
                      </i18n-t>
                    </div>
                  </q-field>
                </div>
              </div>
              <div class= "q-pt-sm" v-if="showSubmitBtn">
              <div
                class="bg-whatsapp corners text-white justify-center row items-center wrapping text-center q-mr-sm q-ml-sm q-mb-sm shadow-4"
                style="font-size: 1.1rem !important; height: 50px; padding: 0 10px; display: flex; align-items: center; justify-content: center;"
                @click="onSubmitApply()"
              >
              <img v-if = "tenantLogoGuid"
                  src="../assets/disclaimer/Digital_Glyph_Green.svg"
                  style="max-width: 30px; margin-right: 10px; height: auto; filter: brightness(0) invert(1);"
                  alt="WhatsApp"
                />
                <span class="text-elipsis" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ startButtonText() }}
                </span>
              </div>
            </div>
            </div>
          </q-slide-transition>
        </q-footer>
      </q-layout>
      <div v-else>
        <div class="disclaimer-bg-image">
          <div v-if="showWhatsAppWaiting">
            <div :style="disclaimerOnlyPageStyle()">
              <div class="row justify-center q-pa-md">
                <img
                  src="../assets/disclaimer/WhatsApp_logo.png"
                  style="height: 80px; filter: brightness(0) invert(1);"
                />
              </div>
              <div v-if="showWhatsAppSpinner" class="row justify-center">
                <q-spinner color="whatsapp" size="xl" />
              </div>
              <div v-if="showOpenWhatsAppBtn" class="row justify-center">
                <q-btn
                  class="q-pr-lg q-pl-lg"
                  rounded
                  no-caps
                  color="whatsapp"
                  size="xl"
                  :label="$t('message.openLbl')"
                  @click="handleRedirectFromBtn()"
                />
              </div>
            </div>
          </div>
          <div
            class="column justify-between"
            :style="disclaimerOnlyPageStyle()"
            v-else
          >
            <div v-if="customDisclaimer">
              <div>
                <q-btn
                  round
                  flat
                  bg-transparent
                  icon="close"
                  class="text-white"
                  @click="showDisclaimerOverlay = !showDisclaimerOverlay"
                />
              </div>
              <div class="row justify-begin">
                <div class="text-white q-pa-lg">
                  {{ additonalText1() }}
                  <div class="text-bold" v-if="additionalText2()">
                    {{ additionalText2() }}
                  </div>
                </div>
                <div class="row full-width q-pb-xl q-pl-sm q-pr-sm">
                  <q-checkbox
                    :disable="showQrCode"
                    class="col-2"
                    size="lg"
                    @update:model-value="handleModelUpdate"
                    v-model="acceptWhatsappDataPrivacy"
                    dark
                    color="whatsapp"
                    v-if="!hideDisclaimerCheckbox"
                  />
                  <div class="text-white col-10">
                    <q-field
                      style="font-size: 0.55rem !important"
                      borderless
                      dense
                      hide-bottom-space
                      color="white"
                      ><div>
                        <i18n-t :keypath="dataPrivacyText()" tag="div">
                          <template #termsOfUsageUrl>
                            <a
                              :href="termsOfUseLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.termsOfUseLbl') }}</a
                            >
                          </template>
                          <template #addnlTermsOfUsageUrl>
                            <a
                              :href="addnlTermsOfUsageUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ addnlTermsOfUsageLbl() }}</a
                            >
                          </template>
                          <template #pitchYouTermsOfUsageUrl>
                            <a
                              :href="termsOfUseLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.pitchYouTermsOfUseLbl') }}</a
                            >
                          </template>
                          <template #dataPrivacyUrl>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ dataPrivacyLabel() }}</a
                            >
                          </template>
                          <template #dataPrivacyFrameworkUrl>
                            <a
                              :href="dataPrivacyFrameworkUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ dataPrivacyFrameworkLabel() }}</a
                            >
                          </template>
                          <template #privacyShieldUrl>
                            <a
                              :href="privacyShieldUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ privacyShieldLabel() }}</a
                            >
                          </template>
                          <template #dataPrivacyInfoUrl>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyInfoLbl') }}</a
                            >
                          </template>
                          <template #dataPrivacyUrlAlt>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyLblAlt') }}</a
                            >
                          </template>
                          <template #additionalTermsUrl>
                            <a
                              :href="additionalTermsLink()"
                              target="_blank"
                              class="text-white"
                              >{{ addnlTermsLbl() }}</a
                            >
                          </template>

                          <template #additionalTermsUrlAlt>
                            <a
                              :href="additionalTermsLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.moreInformationLabelAlt') }}</a
                            >
                          </template>

                          <template #imprintUrl>
                            <a
                              :href="imprintUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.legalNoticeFLbl') }}</a
                            >
                          </template>

                          <template #pitchyouDisclaimer>
                            <a
                              :href="$t('message.defaultDataPrivacyLink')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyLbl') }}</a
                            >
                          </template>
                          <template #pitchyouImprint>
                            <a
                              :href="$t('message.defaultImprintLink')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.legalNoticeFLbl') }}</a
                            >
                          </template>
                          <template #pitchyouTermsOfUse>
                            <a
                              :href="$t('message.defaultTermsOfUseLink')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.termsOfUseLbl') }}</a
                            >
                          </template>
                          <template #whatsAppDisclaimer>
                            <a
                              :href="
                                $t('message.defaultWhatsAppDataPrivacyLink')
                              "
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyTitle') }}</a
                            > </template
                          ><template #whatsAppDataPrivacyUrl>
                            <a
                              :href="whatsAppDataPrivacyUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ whatsAppDataPrivacyLbl() }}</a
                            >
                          </template>
                          <template #whatsAppTermsOfUsageUrl>
                            <a
                              :href="whatsAppTermsOfUsageUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ whatsAppTermsOfUsageLbl() }}</a
                            ></template
                          ><template #newLine>
                            <div style="padding-top: 3px"></div>
                          </template>
                          <template #tcDataPrivacy>
                            <a
                              :href="$t('message.tcDataPrivacy')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyLbl') }}</a
                            >
                          </template>
                          <template #tcImprint>
                            <a
                              :href="$t('message.tcImprint')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.legalNoticeFLbl') }}</a
                            >
                          </template>
                        </i18n-t>
                      </div>
                    </q-field>
                  </div>
                </div>
                <div
                  class="row full-width q-pb-xl q-pl-sm q-pr-sm"
                  v-if="talentPoolDisclaimer"
                >
                  <q-checkbox
                    :disable="showQrCode"
                    class="col-2"
                    size="lg"
                    @update:model-value="handleModelUpdate"
                    v-model="acceptTalentPool"
                    dark
                    color="whatsapp"
                    v-if="!hideDisclaimerCheckbox"
                  />
                  <div class="text-white col-10">
                    <q-field
                      style="font-size: 0.55rem !important"
                      borderless
                      dense
                      hide-bottom-space
                      color="white"
                      ><div>
                        <i18n-t
                          :keypath="'message.talentPoolDisclaimerText'"
                          tag="div"
                        >
                          <template #dataPrivacyUrl>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ dataPrivacyLabel() }}</a
                            >
                          </template>
                          <template #dataPrivacyFrameworkUrl>
                            <a
                              :href="dataPrivacyFrameworkUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ dataPrivacyFrameworkLabel() }}</a
                            >
                          </template>
                          <template #privacyShieldUrl>
                            <a
                              :href="privacyShieldUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ privacyShieldLabel() }}</a
                            >
                          </template>
                        </i18n-t>
                      </div>
                    </q-field>
                  </div>
                </div>
                <div
                  class="text-white q-pl-sm q-pr-sm"
                  style="font-size: 0.55rem !important"
                  v-if="additionalText3()"
                >
                  <i18n-t :keypath="additionalText3()" tag="div">
                    <template #termsOfUsageUrl>
                      <a
                        :href="termsOfUseLink()"
                        target="_blank"
                        class="text-white"
                        >{{ $t('message.termsOfUseLbl') }}</a
                      >
                    </template>
                    <template #addnlTermsOfUsageUrl>
                      <a
                        :href="addnlTermsOfUsageUrl()"
                        target="_blank"
                        class="text-white"
                        >{{ addnlTermsOfUsageLbl() }}</a
                      >
                    </template>
                    <template #pitchYouTermsOfUsageUrl>
                      <a
                        :href="termsOfUseLink()"
                        target="_blank"
                        class="text-white"
                        >{{ $t('message.pitchYouTermsOfUseLbl') }}</a
                      >
                    </template>
                    <template #dataPrivacyUrl>
                      <a
                        :href="dataPrivacyLink()"
                        target="_blank"
                        class="text-white"
                        >{{ dataPrivacyLabel() }}</a
                      >
                    </template>
                    <template #dataPrivacyFrameworkUrl>
                      <a
                        :href="dataPrivacyFrameworkUrl()"
                        target="_blank"
                        class="text-white"
                        >{{ dataPrivacyFrameworkLabel() }}</a
                      >
                    </template>
                    <template #privacyShieldUrl>
                      <a
                        :href="privacyShieldUrl()"
                        target="_blank"
                        class="text-white"
                        >{{ privacyShieldLabel() }}</a
                      >
                    </template>
                    <template #dataPrivacyInfoUrl>
                      <a
                        :href="dataPrivacyLink()"
                        target="_blank"
                        class="text-white"
                        >{{ $t('message.dataPrivacyInfoLbl') }}</a
                      >
                    </template>
                    <template #dataPrivacyUrlAlt>
                      <a
                        :href="dataPrivacyLink()"
                        target="_blank"
                        class="text-white"
                        >{{ $t('message.dataPrivacyLblAlt') }}</a
                      >
                    </template>
                  </i18n-t>
                </div>
              </div>
            </div>

            <div v-if="!customDisclaimer">
              <div>
                <q-btn
                  round
                  flat
                  bg-transparent
                  icon="close"
                  class="text-white"
                  @click="showDisclaimerOverlay = !showDisclaimerOverlay"
                />
              </div>
              <div class="row justify-begin">
                <div class="text-h4 text-white q-pa-lg">
                  {{ $t('message.designDisclaimerAdditionalText1') }}
                  <div class="text-bold">
                    {{ $t('message.designDisclaimerAdditionalText2') }}
                  </div>
                </div>

                <div class="row full-width q-pb-xl q-pl-sm q-pr-sm">
                  <q-checkbox
                    :disable="showQrCode"
                    class="col-2"
                    size="lg"
                    @update:model-value="handleModelUpdate"
                    v-model="acceptWhatsappDataPrivacy"
                    dark
                    color="whatsapp"
                    v-if="!hideDisclaimerCheckbox"
                  />
                  <div class="text-white col-10">
                    <q-field
                      style="font-size: 0.55rem !important"
                      borderless
                      dense
                      hide-bottom-space
                      color="white"
                      ><div>
                        <i18n-t :keypath="dataPrivacyText()" tag="div">
                          <template #termsOfUsageUrl>
                            <a
                              :href="termsOfUseLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.termsOfUseLbl') }}</a
                            >
                          </template>
                          <template #addnlTermsOfUsageUrl>
                            <a
                              :href="addnlTermsOfUsageUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ addnlTermsOfUsageLbl() }}</a
                            >
                          </template>
                          <template #pitchYouTermsOfUsageUrl>
                            <a
                              :href="termsOfUseLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.pitchYouTermsOfUseLbl') }}</a
                            >
                          </template>
                          <template #dataPrivacyUrl>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ dataPrivacyLabel() }}</a
                            >
                          </template>
                          <template #dataPrivacyFrameworkUrl>
                            <a
                              :href="dataPrivacyFrameworkUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ dataPrivacyFrameworkLabel() }}</a
                            >
                          </template>
                          <template #privacyShieldUrl>
                            <a
                              :href="privacyShieldUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ privacyShieldLabel() }}</a
                            >
                          </template>
                          <template #dataPrivacyInfoUrl>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyInfoLbl') }}</a
                            >
                          </template>
                          <template #dataPrivacyUrlAlt>
                            <a
                              :href="dataPrivacyLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyLblAlt') }}</a
                            >
                          </template>
                          <template #additionalTermsUrl>
                            <a
                              :href="additionalTermsLink()"
                              target="_blank"
                              class="text-white"
                              >{{ addnlTermsLbl() }}</a
                            >
                          </template>

                          <template #additionalTermsUrlAlt>
                            <a
                              :href="additionalTermsLink()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.moreInformationLabelAlt') }}</a
                            >
                          </template>

                          <template #imprintUrl>
                            <a
                              :href="imprintUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.legalNoticeFLbl') }}</a
                            >
                          </template>

                          <template #pitchyouDisclaimer>
                            <a
                              :href="$t('message.defaultDataPrivacyLink')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyLbl') }}</a
                            >
                          </template>
                          <template #pitchyouImprint>
                            <a
                              :href="$t('message.defaultImprintLink')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.legalNoticeFLbl') }}</a
                            >
                          </template>
                          <template #pitchyouTermsOfUse>
                            <a
                              :href="$t('message.defaultTermsOfUseLink')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.termsOfUseLbl') }}</a
                            >
                          </template>
                          <template #whatsAppDisclaimer>
                            <a
                              :href="
                                $t('message.defaultWhatsAppDataPrivacyLink')
                              "
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyTitle') }}</a
                            > </template
                          ><template #whatsAppDataPrivacyUrl>
                            <a
                              :href="whatsAppDataPrivacyUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ whatsAppDataPrivacyLbl() }}</a
                            >
                          </template>
                          <template #whatsAppTermsOfUsageUrl>
                            <a
                              :href="whatsAppTermsOfUsageUrl()"
                              target="_blank"
                              class="text-white"
                              >{{ whatsAppTermsOfUsageLbl() }}</a
                            ></template
                          ><template #newLine>
                            <div style="padding-top: 3px"></div>
                          </template>
                          <template #tcDataPrivacy>
                            <a
                              :href="$t('message.tcDataPrivacy')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.dataPrivacyLbl') }}</a
                            >
                          </template>
                          <template #tcImprint>
                            <a
                              :href="$t('message.tcImprint')"
                              target="_blank"
                              class="text-white"
                              >{{ $t('message.legalNoticeFLbl') }}</a
                            >
                          </template>
                        </i18n-t>
                      </div>
                    </q-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  /* desktop */ -->
    <div v-else>
      <q-layout view="hHh lpR fFf" v-if="!showDisclaimerOverlay">
        <q-header elevated style="background-color: #b2b2b2">
          <div v-if="tenantLogoGuid"
            style="
              background-color: #b2b2b2;
              max-height: 100px !important;
            "
          >
            <q-toolbar>
              <div v-if="tenantLogoGuid" class="row items-center full-width">
                <!-- Tenant Logo -->
                <div class="col-5">
                  <img v-if="tenantLogoGuid"
                  :src="logoPath + tenantLogoGuid"
                  class="q-mr-xs tenant-logo"
                  @error="handleImageError"
                  />
                </div>
                <!-- Tenant Name -->
                <div class="col-7">
                  <div
                    class="text-weight-bolder text-white q-pa-xs"
                    style="font-size: 1.4em; padding-left: 5px; color: #514d4d;"
                  >
                    {{ tenantName }}
                  </div>
                </div>
              </div>
            </q-toolbar>
          </div>
          <div v-else
            style="
              background-color: #b2b2b2;
              max-height: 45px !important;
              max-width: 50vh;
              width: 100%;
            "
          >
            <q-toolbar>
              <div class="row justify-evenly items-center full-width">
                <div
                  class="text-weight-bolder q-pa-xs"
                  style="font-size: 1.1em"
                >
                  {{ $t('message.designDisclaimerHeader') }}
                </div>
                <div>
                  <img
                    src="../assets/disclaimer/WhatsApp_logo.png"
                    style="max-width: 150px; filter: brightness(0) invert(1);"
                  />
                </div>
              </div>
            </q-toolbar>
          </div> 

        </q-header>

        <q-page-container>
          <div
            class="bg-image row full-width items-center justify-center"
            :style="desktopBgImageHeight()"
          >
            <div class="row full-width justify-evenly items-center">
              <div
                v-if="!showQrCodePanel"
                class="row justify-evenly full-width"
              >
                <div
                  class="text-white shadow-2 custom-area bg-whatsapp q-pa-md"
                  style="height: 40vh; width: 15vw"
                >
                  <div class="column no-wrap flex-center">
                    <img
                      src="../assets/disclaimer/mobile_device.png"
                      style="max-height: 220px"
                      draggable="false"
                    />
                    <div class="q-mt-md text-center" style="font-size: 1.05rem">
                      {{ step1Text() }}
                    </div>
                  </div>
                </div>

                <div
                  class="text-white shadow-2 custom-area bg-whatsapp"
                  style="
                    height: 40vh;
                    width: 15vw;
                    background-color: rgb(238, 232, 223);
                  "
                >
                  <div class="row justify-center q-pb-md">
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >1.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div
                      class="text-center text-black col-auto"
                      style="font-size: 0.95rem"
                    >
                      {{ $t('message.designDisclaimerStep2_1Text') }}
                      <div class="text-bold" v-if="showDisclaimerText">
                        {{ $t('message.designDisclaimerStep2_2Text') }}
                      </div>
                    </div>
                    <div class="col col-4">
                      <div class="row justify-center items-center q-pt-sm">
                        <img
                          src="../assets/disclaimer/check.png"
                          draggable="false"
                          style="max-height: 40px"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="text-white shadow-2 custom-area bg-whatsapp"
                  style="
                    height: 40vh;
                    width: 15vw;
                    background-color: rgb(238, 232, 223);
                  "
                >
                  <div class="row justify-center q-pb-md">
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >2.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div class="text-center text-black col-auto">
                      <div class="text-bold">
                        {{ $t('message.designDisclaimerStep3_1Text') }}
                      </div>
                      {{ $t('message.designDisclaimerStep3_2Text') }}
                    </div>
                    <div class="col col-6 q-pt-sm">
                      <img
                        src="../assets/disclaimer/start.png"
                        draggable="false"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="text-white shadow-2 custom-area bg-whatsapp"
                  style="
                    height: 40vh;
                    width: 15vw;
                    background-color: rgb(238, 232, 223);
                  "
                >
                  <div class="row justify-center q-pb-md">
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >3.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div class="text-center text-black col-auto">
                      {{ $t('message.designDisclaimerStep4_1Text') }}
                      <div class="text-bold">
                        {{ $t('message.designDisclaimerStep4_2Text') }}
                      </div>
                    </div>
                    <div class="col col-8 q-pt-sm">
                      <img
                        :src="chatImageSrc()"
                        draggable="false"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="text-white shadow-2 custom-area bg-whatsapp"
                  style="
                    height: 40vh;
                    width: 15vw;
                    background-color: rgb(238, 232, 223);
                  "
                >
                  <div
                    class="row full-width justify-center items-center q-pb-md"
                  >
                    <q-avatar
                      class="bg-whatsapp text-bold shadow-4"
                      size="50px"
                      font-size="26px"
                      >4.</q-avatar
                    >
                  </div>
                  <div
                    class="column justify-evenly"
                    style="height: 90%; max-height: 50vh"
                  >
                    <div class="text-center text-black col-auto">
                      {{ $t('message.designDisclaimerStep5_1Text') }}
                      <div class="text-bold">
                        {{ $t('message.designDisclaimerStep5Text') }}
                      </div>
                    </div>
                    <div class="col col-10 q-pt-sm">
                      <img
                        src="../assets/disclaimer/shoes.png"
                        draggable="false"
                        style="height: 100%; max-height: 18vh"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="row justify-center text-white shadow-2 custom-area bg-whatsapp"
                  style="
                    height: 47vh;
                    width: 16vw;
                    background-color: rgb(238, 232, 223);
                  "
                >
                  <div
                    class="column justify-evenly"
                    style="background-color: rgb(238, 232, 223)"
                  >
                    <div v-if="showWhatsAppSpinner" class="row justify-center">
                      <q-spinner color="whatsapp" size="3em" :thickness="10" />
                    </div>
                    <div v-if="showOpenWhatsAppBtn" class="row justify-center">
                      <q-btn
                        class="q-pr-lg q-pl-lg"
                        rounded
                        no-caps
                        color="whatsapp"
                        size="xl"
                        :label="$t('message.openLbl')"
                        @click="handleRedirectFromBtn()"
                      />
                    </div>
                    <div v-if="showQrCode" style="text-align: center">
                      <qrcode
                        :value="qrCodeLink"
                        :options="{
                          width: 200,
                          color: { dark: '#000', light: '#eee8df' },
                          margin: 1
                        }"
                        tag="img"
                      ></qrcode>
                      <div class="scan-text">
                        {{ $t('message.startScanLbl') }}
                      </div>
                      <a
                        :href="qrCodeLink"
                        target="_blank"
                        class="button-desktop"
                        >{{ startChartOptionLbl() }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-page-container>

        <q-footer
          elevated
          style="background-color: #b2b2b2"
          class="row justify-center full-width"
          v-if="showDisclaimerText || showSubmitBtn"
        >
          <q-slide-transition appear>
            <div style="max-width: 95vw; width: 100%" v-if="showDisclaimerText">
              <div class="row justify-center items-center full-width q-pa-xs">
                <div class="col-auto">
                  <q-checkbox
                    :disable="showQrCode"
                    size="lg"
                    @update:model-value="onAnyChange()"
                    v-model="acceptWhatsappDataPrivacy"
                    dark
                    color="whatsapp"
                    v-if="!hideDisclaimerCheckbox"
                  />
                </div>
                <div
                  class="col text-white"
                  @click="
                    !hideDisclaimerCheckbox && !showQrCode
                      ? (acceptWhatsappDataPrivacy = !acceptWhatsappDataPrivacy)
                      : true
                  "
                >
                  <q-field
                    style="font-size: 0.7rem !important"
                    borderless
                    dense
                    hide-bottom-space
                    color="white"
                    ref="acceptWhatsappDataPrivacyRef"
                    :value="acceptWhatsappDataPrivacy"
                    class="cursor-pointer"
                    ><div class="column justify-center">
                      <i18n-t :keypath="dataPrivacyText()" tag="div">
                        <template #termsOfUsageUrl>
                          <a
                            :href="termsOfUseLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.termsOfUseLbl') }}</a
                          >
                        </template>
                        <template #addnlTermsOfUsageUrl>
                          <a
                            :href="addnlTermsOfUsageUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ addnlTermsOfUsageLbl() }}</a
                          >
                        </template>
                        <template #pitchYouTermsOfUsageUrl>
                          <a
                            :href="termsOfUseLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.pitchYouTermsOfUseLbl') }}</a
                          >
                        </template>
                        <template #dataPrivacyUrl>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ dataPrivacyLabel() }}</a
                          >
                        </template>
                        <template #dataPrivacyFrameworkUrl>
                          <a
                            :href="dataPrivacyFrameworkUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ dataPrivacyFrameworkLabel() }}</a
                          >
                        </template>
                        <template #privacyShieldUrl>
                          <a
                            :href="privacyShieldUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ privacyShieldLabel() }}</a
                          >
                        </template>
                        <template #dataPrivacyInfoUrl>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyInfoLbl') }}</a
                          >
                        </template>
                        <template #dataPrivacyUrlAlt>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyLblAlt') }}</a
                          >
                        </template>
                        <template #additionalTermsUrl>
                          <a
                            :href="additionalTermsLink()"
                            target="_blank"
                            class="text-white"
                            >{{ addnlTermsLbl() }}</a
                          >
                        </template>

                        <template #additionalTermsUrlAlt>
                          <a
                            :href="additionalTermsLink()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.moreInformationLabelAlt') }}</a
                          >
                        </template>

                        <template #imprintUrl>
                          <a
                            :href="imprintUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.legalNoticeFLbl') }}</a
                          >
                        </template>

                        <template #pitchyouDisclaimer>
                          <a
                            :href="$t('message.defaultDataPrivacyLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyLbl') }}</a
                          >
                        </template>
                        <template #pitchyouImprint>
                          <a
                            :href="$t('message.defaultImprintLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.legalNoticeFLbl') }}</a
                          >
                        </template>
                        <template #pitchyouTermsOfUse>
                          <a
                            :href="$t('message.defaultTermsOfUseLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.termsOfUseLbl') }}</a
                          >
                        </template>
                        <template #whatsAppDisclaimer>
                          <a
                            :href="$t('message.defaultWhatsAppDataPrivacyLink')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyTitle') }}</a
                          >
                        </template>
                        <template #whatsAppDataPrivacyUrl>
                          <a
                            :href="whatsAppDataPrivacyUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ whatsAppDataPrivacyLbl() }}</a
                          >
                        </template>
                        <template #whatsAppTermsOfUsageUrl>
                          <a
                            :href="whatsAppTermsOfUsageUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ whatsAppTermsOfUsageLbl() }}</a
                          ></template
                        >
                        <template #newLine
                          ><div style="padding-top: 3px"></div>
                        </template>
                        <template #tcDataPrivacy>
                          <a
                            :href="$t('message.tcDataPrivacy')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.dataPrivacyLbl') }}</a
                          >
                        </template>
                        <template #tcImprint>
                          <a
                            :href="$t('message.tcImprint')"
                            target="_blank"
                            class="text-white"
                            >{{ $t('message.legalNoticeFLbl') }}</a
                          >
                        </template>
                      </i18n-t>
                    </div>
                  </q-field>
                </div>
              </div>
              <div
                v-if="talentPoolDisclaimer"
                class="row justify-center items-center full-width q-pl-xs q-pr-xs"
              >
                <div class="col-auto">
                  <q-checkbox
                    :disable="showQrCode"
                    size="lg"
                    @update:model-value="onAnyChange()"
                    v-model="acceptTalentPool"
                    dark
                    color="whatsapp"
                    v-if="!hideDisclaimerCheckbox"
                  />
                </div>
                <div
                  class="col text-white"
                  @click="
                    !hideDisclaimerCheckbox && !showQrCode
                      ? (acceptTalentPool = !acceptTalentPool)
                      : true
                  "
                >
                  <q-field
                    style="font-size: 0.7rem !important"
                    borderless
                    dense
                    hide-bottom-space
                    color="white"
                    ref="acceptTalentPoolRef"
                    :value="acceptTalentPool"
                    class="cursor-pointer"
                    ><div class="column justify-center">
                      <i18n-t
                        :keypath="'message.talentPoolDisclaimerText'"
                        tag="div"
                      >
                        <template #dataPrivacyUrl>
                          <a
                            :href="dataPrivacyLink()"
                            target="_blank"
                            class="text-white"
                            >{{ dataPrivacyLabel() }}</a
                          >
                        </template>
                        <template #dataPrivacyFrameworkUrl>
                          <a
                            :href="dataPrivacyFrameworkUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ dataPrivacyFrameworkLabel() }}</a
                          >
                        </template>
                        <template #privacyShieldUrl>
                          <a
                            :href="privacyShieldUrl()"
                            target="_blank"
                            class="text-white"
                            >{{ privacyShieldLabel() }}</a
                          >
                        </template>
                      </i18n-t>
                    </div>
                  </q-field>
                </div>
              </div>
              <div v-if="showSubmitBtn">
                <div
                  class="bg-whatsapp corners text-white justify-center row items-center wrapping text-center q-mr-sm q-ml-sm q-mb-sm shadow-4 cursor-pointer"
                  style="font-size: 1.1rem !important; height: 50px"
                  @click="onSubmitApply()"
                >
                <img v-if="tenantLogoGuid"
                    src="../assets/disclaimer/Digital_Glyph_Green.svg"
                    style="max-width: 30px; margin-right: 18px; filter: brightness(0) invert(1);"
                    alt="WhatsApp"
                  />
                  {{ startButtonText() }}
                </div>
              </div>
            </div>
          </q-slide-transition>
        </q-footer>
      </q-layout>
    </div>
  </div>
</template>

<script setup lang="ts">
import { showErrorMsgToast } from '@/common';
import {
  DisclaimerTargetResponse,
  ILabelValue,
  ShortUrlRequest
} from '@/store/models';
import privacyConfirmModule from '@/store/modules/privacyConfirmModule';
import shortUrlModule from '@/store/modules/shortUrlModule';
import tenantModule from '@/store/modules/tenantModule';
import Cookies from 'js-cookie';
import { Platform } from 'quasar';
import { nextTick, onMounted } from 'vue';

import { useQuasar } from 'quasar';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, te, locale } = useI18n();

const name = ref('WhatsappPage');
const acceptWhatsappDataPrivacy = ref(false);
const acceptTalentPool = ref(false);
const showQrCode = ref(false);
const qrCodeLink = ref('');
const selectedLanguage = ref<ILabelValue | null>(null);
const tenantDataPrivacyUrl = ref<string | null>(null);
const tenantName = ref<string | null>(null);
const tenantIdentifier = ref<string | null>(null);
const language = ref(navigator.language);
const tenantInfoLoaded = ref(false);
const defaultLanguageCode = ref('de');
const dataPrivacyUrl = ref<string | null>(null);
const additionalTermsUrl = ref(t('message.additionalTermsUrl') as string);
const disclaimerTarget = ref<DisclaimerTargetResponse | null>(null);
const showDisclaimerText = ref(false);
const showSubmitBtn = ref(false);
const disclaimerGuid = ref<string | undefined>(undefined);
const currentIndex = ref('1');
const showDisclaimerOverlay = ref(false);
const showWhatsAppWaiting = ref(false);
const showWhatsAppSpinner = ref(false);
const showQrCodePanel = ref(false);
const customDisclaimer = ref(true);
const contactDisclaimer = ref(false);
const talentPoolDisclaimer = ref(false);
const hideDisclaimerCheckbox = ref(false);
const showOpenWhatsAppBtn = ref(false);
const redirectUrl = ref('');
const firstRedirect = ref(true);
const alternateUrl = ref('');
const useDirectUrl = ref(true);
const useWindowOpen = ref(true);
const tenantLogoUrl =  ref<string | null>(null);
let logoPath = ref('/api/media/v1/logo/');
const tenantLogoGuid =  ref<string | null>(null);


function additonalText1() {
  if (te('message.designDisclaimerAdditionalText1_' + tenantIdentifier.value)) {
    return t(
      'message.designDisclaimerAdditionalText1_' + tenantIdentifier.value
    );
  }

  return t('message.designDisclaimerAdditionalText1');
}

function additionalText2() {
  if (t('message.designDisclaimerAdditionalText1_' + tenantIdentifier.value)) {
    return null;
  }

  return t('message.designDisclaimerAdditionalText2');
}

function additionalText3() {
  if (te('message.designDisclaimerAdditionalText3_' + tenantIdentifier.value)) {
    return 'message.designDisclaimerAdditionalText3_' + tenantIdentifier.value;
  }

  return null;
}

function iconStyleClass() {
  return $q.platform.is.mobile
    ? 'full-width column justify-center items-center '
    : 'full-width row items-center ';
}

function isRenderTenantDataPrivacy(): boolean {
  if (
    tenantModule &&
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.dataPrivacyUrl
  ) {
    return true;
  }
  return false;
}

function swipableAreaStyle() {
  if (currentIndex.value == '1') {
    return undefined;
  }

  return 'background-color: rgb(238,232,223)';
}

function dataPrivacyText() {
  if (tenantModule.tenantInfoLite) {
    if (tenantModule.tenantInfoLite.ps) {
      return 'message.combinedDisclaimerText_prescreen';
    }

    if (tenantModule.tenantInfoLite.customDisclaimer) {
      const translationKey =
        'message.combinedDisclaimerText_' +
        tenantModule.tenantInfoLite.identifier.split('-').join('_');
      if (te(translationKey)) {
        return translationKey;
      }
    }
  }

  return 'message.combinedDisclaimerText';
}

function startButtonText() {
  if (contactDisclaimer.value) {
    return t('message.designDisclaimerStartContactButtonText');
  }

  return t('message.designDisclaimerStartButtonText');
}

function step1Text() {
  if (contactDisclaimer.value) {
    return t('message.designDisclaimerStep1ContactText');
  }

  return t('message.designDisclaimerStep1Text');
}

function whatsAppPrivacyText() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.customDisclaimer
  ) {
    return (
      'message.whatsappDataPrivacyTxt_' +
      tenantModule.tenantInfoLite.identifier.split('-').join('_')
    );
  }

  return 'message.whatsappDataPrivacyTxt';
}

function acceptDataPrivacyText() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.customDisclaimer
  ) {
    return t(
      'message.acceptWhatsappDataPrivacyTxt_' +
        +tenantModule.tenantInfoLite.identifier.replace('-', '_')
    );
  }

  return t('message.acceptWhatsappDataPrivacyTxt');
}

function dataPrivacyLink() {
  if (dataPrivacyUrl.value) {
    return dataPrivacyUrl.value;
  } else if (tenantModule.tenantInfoLite) {
    return tenantModule.tenantInfoLite.dataPrivacyUrl;
  } else {
    return t('message.defaultDataPrivacyLink');
  }
}

function termsOfUseLink() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.overridePitchYouLinks
  ) {
    return tenantModule.tenantInfoLite.termsOfUseUrl;
  }

  return t('message.termsOfUserDisclaimerUrl');
}

function additionalTermsLink() {
  if (
    tenantModule.tenantInfoLite &&
    tenantModule.tenantInfoLite.additionalTermsUrl
  ) {
    return tenantModule.tenantInfoLite.additionalTermsUrl;
  }

  return t('message.additionalTermsUrl');
}

function chatImageSrc(): string {
  try {
    const languageCode = currentLanguage();
    if (languageCode) {
      return require('../assets/disclaimer/Disclaimer_Chat_' +
        languageCode.toUpperCase() +
        '.png');
    }
  } catch (error) {
    return require('../assets/disclaimer/Disclaimer_Chat_EN.png');
  }

  return require('../assets/disclaimer/Disclaimer_Chat_EN.png');
}

onMounted(async () => {
  locale.value = currentLanguage() as string;
  onInitialPageLoad();
});

async function onInitialPageLoad() {
  try {
    showQrCode.value = false;
    await loadTenantInfoLite();
    if (tenantModule.tenantInfoLite) {
      defaultLanguageCode.value =
        tenantModule.tenantInfoLite.defaultLanguageCode;
      tenantLogoUrl.value =  tenantModule.tenantInfoLite.logo || null;
      tenantLogoGuid.value = tenantModule.tenantInfoLite.logoGuid || null;
      customDisclaimer.value = tenantModule.tenantInfoLite.customDisclaimer;
    }

    await getDisclaimerTarget();
    if (disclaimerTarget.value) {
      if (
        disclaimerTarget.value.shortUrlDto &&
        'VIBER' == disclaimerTarget.value.shortUrlDto.channelType
      ) {
        shortUrlModule.setShortUrlResult(disclaimerTarget.value.shortUrlDto);
        router.push({
          name: 'viber_discl',
          query: route.query
        });
        return;
      }

      if (disclaimerTarget.value.dataPrivacyUrl) {
        dataPrivacyUrl.value = disclaimerTarget.value.dataPrivacyUrl;
      }

      contactDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.contactDisclaimer;
      talentPoolDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.talentPoolDisclaimer || false;
    }

    if (
      isMobileDevice() &&
      disclaimerTarget.value &&
      disclaimerTarget.value.shortUrlDto &&
      disclaimerTarget.value.shortUrlDto.directAccess
    ) {
      handleDirectAccess(disclaimerTarget.value);
    } else {
      if (
        disclaimerTarget.value &&
        disclaimerTarget.value.shortUrlDto &&
        !disclaimerTarget.value.shortUrlDto.hideDisclaimer
      ) {
        if (
          !isMobileDevice() ||
          !customDisclaimer.value ||
          (customDisclaimer.value && hideDisclaimerCheckbox.value)
        ) {
          showDisclaimerText.value = true;
        }
      }
      showSubmitBtn.value = true;
    }
  } catch (error) {
    console.log(error);
  }
}

function imprintUrl() {
  if (route.query.imprint) {
    return route.query.imprint as string;
  }
  if (tenantModule.tenantInfoLite && tenantModule.tenantInfoLite.imprintUrl) {
    return tenantModule.tenantInfoLite.imprintUrl;
  }

  return '';
}

function handleDirectAccess(target: DisclaimerTargetResponse) {
  const redirectTarget =
    (target.shortUrlDto.directAccessRedirectUrl as string) +
    target.shortUrlDto.directAccessFirstMessageText +
    ' ';
  redirectUrl.value = redirectTarget;
  alternateUrl.value =
    (target.shortUrlDto.alternateAccessRedirectUrl as string) +
    target.shortUrlDto.directAccessFirstMessageText +
    ' ';
  handleRedirect(redirectTarget);
}

async function getDisclaimerTarget() {
  try {
    disclaimerTarget.value = await shortUrlModule.doGetDisclaimerTarget(
      getShortUrlRequest()
    );
  } catch (error) {
    console.log(error);
    router.replace({ name: 'error' });
  }
}

function getShortUrlRequest(): ShortUrlRequest {
  setCookie();
  const request: ShortUrlRequest = {
    guid: route.query.id as string,
    externalCall:
      route.query && route.query.extcall
        ? (route.query.extcall as unknown as boolean)
        : false,
    apiCall:
      route.query && route.query.apicall
        ? (route.query.apicall as unknown as boolean)
        : false,
    jkey:
      route.query && route.query.jkey
        ? (route.query.jkey as string)
        : undefined,
    languageCode: currentLanguage(),
    countryCode: navigator.language,
    additionalParams: JSON.stringify(route.query),
    disclaimerGuid: disclaimerGuid.value,
    platformType: getPlatform(),
    directRedirect:
      disclaimerTarget.value && disclaimerTarget.value.shortUrlDto
        ? disclaimerTarget.value.shortUrlDto.hideDisclaimer
        : false
  };

  if (route.query.utm_source) {
    request.utm_source = (route.query.utm_source as string) || undefined;
  }

  if (route.query.utm_medium) {
    request.utm_medium = (route.query.utm_medium as string) || undefined;
  }

  if (route.query.utm_campaign) {
    request.utm_campaign = (route.query.utm_campaign as string) || undefined;
  }

  if (route.query.utm_content) {
    request.utm_content = (route.query.utm_content as string) || undefined;
  }

  if (route.query.title) {
    request.title = (route.query.title as string) || undefined;
  }
  if (route.query.company) {
    request.company = (route.query.company as string) || undefined;
  }

  if (route.query.externalJobId) {
    request.externalJobId = (route.query.externalJobId as string) || undefined;
  }

  request.channelType = 'WB';
  request.userAgent = navigator.userAgent;
  return request;
}

function setCookie(): void {
  disclaimerGuid.value = Cookies.get('disclaimerGuid');
  if (!disclaimerGuid.value) {
    getGuidCookie();
    if (disclaimerGuid.value) {
      Cookies.set('disclaimerGuid', disclaimerGuid.value);
    }
  }
}

function getPlatform(): string {
  if (Platform.is.desktop) {
    return 'DESKTOP';
  } else if (Platform.is.ios) {
    return 'IOS';
  } else if (Platform.is.android) {
    return 'ANDROID';
  } else if (Platform.is.chrome || Platform.is.edge) {
    return 'CHROME';
  } else {
    return 'FIREFOX';
  }
}

function currentLanguage(): string {
  if (language.value && language.value.length > 2) {
    return language.value.substring(0, 2);
  }

  return language.value;
}

async function loadTenantInfoLite() {
  try {
    const tenant = tenantModule.tenantInfoLite || null;
    if (!tenant) {
      await tenantModule.loadTenantInfoLite(locale.value);
    }
    if (tenantModule.tenantInfoLite) {
      let enableWhatsApp = tenantModule.tenantInfoLite.enableWhatsapp;
      let readOnlyTenant = tenantModule.tenantInfoLite.readonly;
      let salesTokenSet = route.query.sid || route.params.sid;
      tenantModule.tenantInfoLite.hideClientDataSecurity;
      if (!enableWhatsApp || (readOnlyTenant && !salesTokenSet)) {
        router.replace({ name: 'home' });
      } else {
        if (
          salesTokenSet &&
          !(await privacyConfirmModule.validateTestUserToken(
            salesTokenSet as string
          ))
        ) {
          router.replace({ name: 'home' });
        }
      }
      tenantDataPrivacyUrl.value =
        tenantModule.tenantInfoLite.dataPrivacyUrl || null;
      tenantName.value = tenantModule.tenantInfoLite.name || null;
      tenantIdentifier.value = tenantModule.tenantInfoLite.identifier || null;
      hideDisclaimerCheckbox.value =
        tenantModule.tenantInfoLite.hideDisclaimerCheckbox || false;
      if (hideDisclaimerCheckbox.value) {
        acceptWhatsappDataPrivacy.value = true;
        acceptTalentPool.value = true;
      }
      tenantInfoLoaded.value = true;
    }
  } catch (error) {
    router.replace({ name: 'home' });
    console.log(error);
  }
}

async function onApplyDisclaimer() {
  if (!acceptWhatsappDataPrivacy.value) {
    return;
  }

  if (talentPoolDisclaimer.value && !acceptTalentPool.value) {
    return;
  }
  try {
    showWhatsAppWaiting.value = true;
    showWhatsAppSpinner.value = true;
    await applyDisclaimer();
    if (disclaimerTarget.value) {
      handleDirectAccess(disclaimerTarget.value);
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } catch (error) {
    console.log(error);
    showErrorMsgToast(t('message.failedProcessMsg') as string);
  }
  showWhatsAppSpinner.value = false;
}

function handleModelUpdate(value: boolean) {
  nextTick(() => {
    if (value) {
      onApplyDisclaimer();
    }
  });
}

async function onSubmitApply() {
  try {
    if (isMobileDevice()) {
      if (
        disclaimerTarget.value &&
        disclaimerTarget.value.shortUrlDto &&
        disclaimerTarget.value.shortUrlDto.hideDisclaimer
      ) {
        showWhatsAppWaiting.value = true;
        showDisclaimerOverlay.value = true;
        showWhatsAppSpinner.value = true;
        await getDisclaimerTarget();
        handleDirectAccess(disclaimerTarget.value);
      } else {
        if (acceptWhatsappDataPrivacy.value) {
          showWhatsAppWaiting.value = true;
          showDisclaimerOverlay.value = true;
          showWhatsAppSpinner.value = true;
          await applyDisclaimer();
          if (disclaimerTarget.value) {
            handleDirectAccess(disclaimerTarget.value);
          } else {
            showErrorMsgToast(t('message.failedProcessMsg') as string);
          }
        } else {
          showDisclaimerOverlay.value = true;
        }
      }
    } else {
      if (
        (acceptWhatsappDataPrivacy.value && !talentPoolDisclaimer.value) ||
        (acceptWhatsappDataPrivacy.value &&
          talentPoolDisclaimer.value &&
          acceptTalentPool.value) ||
        (disclaimerTarget.value &&
          disclaimerTarget.value.shortUrlDto &&
          disclaimerTarget.value.shortUrlDto.hideDisclaimer)
      ) {
        showSubmitBtn.value = false;
        showWhatsAppSpinner.value = true;
        showQrCodePanel.value = true;
        if (
          disclaimerTarget.value &&
          disclaimerTarget.value.shortUrlDto &&
          !disclaimerTarget.value.shortUrlDto.hideDisclaimer
        ) {
          await applyDisclaimer();
        } else if (
          disclaimerTarget.value &&
          disclaimerTarget.value.shortUrlDto &&
          disclaimerTarget.value.shortUrlDto.hideDisclaimer
        ) {
          await getDisclaimerTarget();
        }

        if (disclaimerTarget.value) {
          handleDirectAccess(disclaimerTarget.value);
          showWhatsAppSpinner.value = false;
        } else {
          showErrorMsgToast(t('message.failedProcessMsg') as string);
        }
      }
    }

    /* if (
        disclaimerTarget &&
        disclaimerTarget.shortUrlDto &&
        disclaimerTarget.shortUrlDto.hideDisclaimer &&
        isMobileDevice
      ) {
        showWhatsAppWaiting = true;
        showDisclaimerOverlay = true;
        showWhatsAppSpinner = true;
        await getDisclaimerTarget();
        handleDirectAccess(disclaimerTarget);
      } else {
        if (isMobileDevice) {
          if (acceptWhatsappDataPrivacy) {
            showWhatsAppWaiting = true;
            showDisclaimerOverlay = true;
            showWhatsAppSpinner = true;
            await applyDisclaimer();
            if (disclaimerTarget) {
              handleDirectAccess(disclaimerTarget);
            } else {
              showErrorMsgToast(
                this,
                t('message.failedProcessMsg') as string
              );
            }
          } else {
            showDisclaimerOverlay = true;
          }
        } else {
          //validate checkbox
          if (
            acceptWhatsappDataPrivacy ||
            (!isMobileDevice &&
              disclaimerTarget &&
              disclaimerTarget.shortUrlDto &&
              disclaimerTarget.shortUrlDto.hideDisclaimer)
          ) {
            showSubmitBtn = false;
            showWhatsAppSpinner = true;
            showQrCodePanel = true;
            await applyDisclaimer();
            if (disclaimerTarget) {
              handleDirectAccess(disclaimerTarget);
              showWhatsAppSpinner = false;
            } else {
              showErrorMsgToast(
                this,
                t('message.failedProcessMsg') as string
              );
            }
          }
        }
      } */
  } catch (error) {
    console.log(error);
    showErrorMsgToast(t('message.failedProcessMsg') as string);
  }

  showWhatsAppSpinner.value = false;
}

async function applyDisclaimer() {
  try {
    const request: ShortUrlRequest = getShortUrlRequest();
    request.dataPrivacyUrl = dataPrivacyUrl.value as string;
    if (talentPoolDisclaimer.value && acceptTalentPool.value) {
      request.acceptTalentPool = true;
    }
    disclaimerTarget.value = await shortUrlModule.doApplyDisclaimer(request);
  } catch (error) {
    console.log(error);
  }
}

async function getGuidCookie() {
  disclaimerGuid.value = (
    Math.random().toString(36).substring(2, 6) +
    Math.random().toString(36).substring(2, 6)
  ).toUpperCase();
}

function onAnyChange() {
  showQrCode.value = false;
  qrCodeLink.value = '';
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function handleRedirect(redirectUri: string): void {
  if (isMobileDevice()) {
    try {
      setTimeout(() => {
        if (!document.hidden) {
          showOpenWhatsAppBtn.value = true;
        }
      }, 1000);
      window.location.href = redirectUri;
    } catch (error) {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
      window.location.href = redirectUri;
    }
  } else {
    qrCodeLink.value = redirectUri;
    showQrCode.value = true;
  }
}

function handleRedirectFromBtn(): void {
  let url = useDirectUrl.value ? redirectUrl.value : alternateUrl.value;
  if (useWindowOpen.value) {
    window.open(url, '_system');
  } else {
    useDirectUrl.value = !useDirectUrl.value;
    window.location.href = url;
  }
  useWindowOpen.value = !useWindowOpen.value;

  // if (firstRedirect.value) {
  //   firstRedirect.value = false;
  //   window.open(redirectUrl.value, '_system');
  // } else {
  //   window.location.href = redirectUrl.value;
  // }
}

function showProcessError(): void {
  $q.notify({
    color: 'pink-7',
    icon: 'warning',
    position: 'top',
    message: t('message.failedProcessMsg') as string
  });
}

function isMobileDevice(): boolean {
  return $q.platform.is.mobile || false;
}

function desktopBgImageHeight() {
  if (showDisclaimerText.value && showSubmitBtn) {
    return {
      height: $q.screen.height - 200 + 'px'
    };
  }

  if (showSubmitBtn.value) {
    return {
      height: $q.screen.height - 105 + 'px'
    };
  }

  return {
    height: $q.screen.height - 45 + 'px'
  };
}

function contentHeight() {
  if (showDisclaimerText.value && showSubmitBtn) {
    return {
      height: $q.screen.height - 200 + 'px'
    };
  }

  if (showSubmitBtn.value) {
    return {
      height: $q.screen.height - 105 + 'px'
    };
  }

  return {
    height: $q.screen.height - 45 + 'px'
  };
}

function swipeAreaContentHeight() {
  return {
    height: $q.screen.height - 350 + 'px'
  };
}

function swipableContentHeight() {
  return $q.screen.height - 250 + 'px';
}

function disclaimerOnlyPageStyle() {
  return {
    height: $q.screen.height + 'px'
  };
}

function dataPrivacyLabel() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.dataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.dataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_') //replaceAll('-', '_')
      );
    }
  }

  return t('message.dataPrivacyLbl');
}

function dataPrivacyFrameworkUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.dataPrivacyFrameworkUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.dataPrivacyFrameworkUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return t('message.dataPrivacyFrameworkUrl');
}
function dataPrivacyFrameworkLabel() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.dataPrivacyFrameworkLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.dataPrivacyFrameworkLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return t('message.dataPrivacyFrameworkLbl');
}

function privacyShieldUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.privacyShieldUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.privacyShieldUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return t('message.privacyShieldUrl');
}
function privacyShieldLabel() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.privacyShieldLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.privacyShieldLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.privacyShieldLbl');
}

function addnlTermsOfUsageUrl() {
  if (tenantModule.tenantInfoLite) {
    if (tenantModule.tenantInfoLite.ps) {
      return t('message.addnlTermsOfUsageUrl_prescreen');
    }
    if (
      te(
        'message.addnlTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.addnlTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }

  return termsOfUseLink();
}
function addnlTermsOfUsageLbl() {
  if (tenantModule.tenantInfoLite) {
    if (tenantModule.tenantInfoLite.ps) {
      return t('message.addnlTermsOfUsageLbl_prescreen');
    }
    if (
      te(
        'message.addnlTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.addnlTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.addnlTermsOfUsageLbl');
}

function addnlTermsLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.addnlTermsLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.addnlTermsLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.moreInformationLabel');
}

function whatsAppDataPrivacyLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppDataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppDataPrivacyLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.whatsAppDataPrivacyLbl');
}

function whatsAppDataPrivacyUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppDataPrivacyUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppDataPrivacyUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.defaultWhatsAppDataPrivacyUrl');
}

function whatsAppTermsOfUsageUrl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppTermsOfUsageUrl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.defaultWhatsAppTermsOfUsageUrl');
}
function whatsAppTermsOfUsageLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.whatsAppTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.whatsAppTermsOfUsageLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.whatsAppTermsOfUsageLbl');
}
function handleImageError(event: any) {
    event.target.style.display = 'none';  // Hide the image if it fails to load
  }

  function startChartOptionLbl() {
  if (tenantModule.tenantInfoLite) {
    if (
      te(
        'message.startChartOptionLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      )
    ) {
      return t(
        'message.startChartOptionLbl_' +
          tenantModule.tenantInfoLite.identifier.split('-').join('_')
      );
    }
  }
  return t('message.startChartOptionLbl');
}
</script>

<style>
.bg-image {
  background-image: url(../assets/disclaimer/wa_bg.png);
}

.disclaimer-bg-image {
  background-image: url(../assets/disclaimer/disclaimer_bg.png);
}
.custom-area {
  width: 80%;
  border-radius: 25px;
  padding: 8px;
}
.custom-info pre {
  width: 180px;
  font-size: 12px;
}
.btn-border {
  border-style: solid;
  border-width: 5px;
  border-color: white;
}

.q-checkbox--dark .q-checkbox__inner--truthy {
  color: #45bd59;
}

.dot {
  border: 4px solid white;
}

.corners {
  border-radius: 25px;
}

.button-desktop {
  font-size: 13px;
  font-weight: bold;
  border-radius: 20px;
  border: none;
  color: #25d366;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #551a8b;
  }
}

.scan-text {
  font-weight: bold;
  width: 100%;
  font-size: 17px;
  padding: 10px 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  background-color: #25d366;
  color: #fcf5eb;
  transition: background-color 0.3s;
  text-align: center;
}

.tenant-logo {
  max-height: 90px;  
  object-fit: contain; 
  height: auto;       
  width: auto;         
  display: block;
}

.tenant-name {
  word-wrap: break-word; 
  white-space: normal;  
  text-align: center;  
}

/* Optional: Adjust font size for smaller screens */
@media (max-width: 600px) {
  .tenant-name {
    font-size: 1 rem; /* Smaller font for small screens */
  }
}  
</style>
